import fp from 'lodash/fp';
import React from 'react';
import { FormSpyProps } from 'react-final-form';

import { useTranslation } from 'Modules/core/i18n';

import styles from './index.module.scss';


export const PersonalDataError: FormSpyProps['component'] = ({ errors }) => {
    const { t } = useTranslation('formField');
    return fp.get('usePersonalData', errors)
        ? (
            <div className={styles.container}>
                <span>
                    {t('usePersonalData')}
                </span>
            </div>
        )
        : null;
};
